import React, { useState, useEffect, useCallback } from 'react';
import * as Contexts from 'src/contexts';
import { redirect, hasAuth } from './libraries/auth.library';
import ToasterContainer from './components/atoms/toaster/toaster.component';

const App: React.FC = ({ children }) => {
  // Checks for the Active Directory Token
  const [ready, setReady] = useState(false);

  const checkAuth = useCallback(async () => {
    const isAuth = await hasAuth();

    if (!isAuth) {
      redirect();
    } else {
      setReady(true);
    }
  }, [setReady]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (!ready) {
    return null;
  }

  // Combines all the context providers
  const childrenWithContext = Object.keys(Contexts).reduce((child, key) => {
    const ContextProvider = Contexts[key];

    return <ContextProvider>{child}</ContextProvider>;
  }, children);

  return (
    <>
      {childrenWithContext}
      <ToasterContainer />
    </>
  );
};

export default App;
